import { ViewModel, View, ObservableArray } from "binder"
import { ProductionOrderEditorView } from "./productionOrderEditor-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { Product, ProductSelectorViewModel } from "../Selectors/productSelector-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ProductLineSelectorViewModel } from "../Selectors/productLineSelector-viewModel";
import { WorkStationSelectorViewModel } from "../Selectors/workStationSelector-viewModel";
import { WorkingShiftSelectorViewModel } from "../Selectors/workingShiftSelector-viewModel";

export class ProductionOrderEditorViewModel extends ViewModel implements IProductionOrder, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater, isDetail: boolean = false) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.isDetail = isDetail;

        this.productLineSelector = new ProductLineSelectorViewModel(this);
        this.workStationSelector = new WorkStationSelectorViewModel(this);
        this.workingShiftSelector = new WorkingShiftSelectorViewModel(this);
        this.productSelector = new ProductSelectorViewModel(this);
        this.productSelector.onSelectionChanged = x => this.onProductChanged(x);

        this.serialNumbers = ObservableArray.create<SerialNumber>();

        // this.supplierSelector = new SupplierSelectorViewModel(this);
        // this.supplierSelector.onSelectionChanged = x => {
        //     this.onSupplierChanged(x);

        //     this.supplierFromCavitySelector.supplierId = x.id;
        //     this.supplierFromCavitySelector.refresh();
        //     this.supplierFromCavitySelector.onSelectionChanged = x => this.onSupplierFromCavityChanged(x);

        //     this.supplierFromProductSelector.supplierId = x.id;
        //     this.supplierFromProductSelector.refresh();
        //     this.supplierFromProductSelector.onSelectionChanged = x => this.onSupplierFromProductChanged(x);
        // }
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductionOrderEditorView();
    }
    public getTypeId(): string {
        return "VM-05ED8D30-4B0B-4E8A-A916-1325151DE83C"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set from(v: number) { this._from = v; } public get from(): number { return this._from; } private _from: number;
    public set until(v: number) { this._until = v; } public get until(): number { return this._until; } private _until: number;
    public set serialNumbers(v: ObservableArray<SerialNumber>) { this._serialNumbers = v; } public get serialNumbers(): ObservableArray<SerialNumber> { return this._serialNumbers; } private _serialNumbers: ObservableArray<SerialNumber>;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId; } private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productSelector(v: ProductSelectorViewModel) { this._productSelector = v; } public get productSelector(): ProductSelectorViewModel { return this._productSelector; } private _productSelector: ProductSelectorViewModel;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set productLineSelector(v: ProductLineSelectorViewModel) { this._productLineSelector = v; } public get productLineSelector(): ProductLineSelectorViewModel { return this._productLineSelector; } private _productLineSelector: ProductLineSelectorViewModel;
    public set workingShiftName(v: string) { this._workingShiftName = v; } public get workingShiftName(): string { return this._workingShiftName; } private _workingShiftName: string;
    public set workingShiftSelector(v: WorkingShiftSelectorViewModel) { this._workingShiftSelector = v; } public get workingShiftSelector(): WorkingShiftSelectorViewModel { return this._workingShiftSelector; } private _workingShiftSelector: WorkingShiftSelectorViewModel;
    public set workStationName(v: string) { this._workStationName = v; } public get workStationName(): string { return this._workStationName; } private _workStationName: string;
    public set workStationSelector(v: WorkStationSelectorViewModel) { this._workStationSelector = v; } public get workStationSelector(): WorkStationSelectorViewModel { return this._workStationSelector; } private _workStationSelector: WorkStationSelectorViewModel;
    public set isDetail(v: boolean) { this._isDetail = v; } public get isDetail(): boolean { return this._isDetail; } private _isDetail: boolean;
    public set time(v: string) { this._time = v; } public get time(): string { return this._time; } private _time: string;

    closePopup(result?: any) {

    }

    onProductChanged(product: Product) {
        this.productId = product?.id;
    }
    setProductId(id: string) {
        this.productSelector.selectById(id);
    }
    getProductId(): string {
        return this.productSelector.selectedItem?.id;
    }

    setProductName(name: string) {
        this.productName = name;
    }
    getProductName(): string {
        return this.productName;
    }

    setProductLineId(id: string) {
        this.productLineSelector.selectById(id);
    }
    getProductLineId(): string {
        return this.productLineSelector.selectedItem?.id;
    }

    setWorkingShiftId(id: string) {
        this.workingShiftSelector.selectById(id);
    }
    getWorkingShiftId(): string {
        return this.workingShiftSelector.selectedItem?.id;
    }

    setWorkStationId(id: string) {
        this.workStationSelector.selectById(id);
    }
    getWorkStationId(): string {
        return this.workStationSelector.selectedItem?.id;
    }

    setUntil(input: any) {
        this.until = input;
    }
    getUntil(): number {
        return this.until;
    }
    setFrom(input: any) {
        this.from = input;
    }
    getFrom(): number {
        return this.from;
    }

    setSerialNumbers(serialNumbers: string[]) {
        this.serialNumbers.update(...serialNumbers.map(item => {
            let serialNumbers = new SerialNumber(this);
            for (var i = this.from; i <= this.until; i++) {
                serialNumbers.serialNumber = item;
            }
            return serialNumbers;
        }));
    }
    getSerialNumbers(): string[] {
        let serialNumbers = [];
        for (let i = this.from; i <= this.until; i++) {
            serialNumbers.push(i.toString());
        }
        return serialNumbers;
    }

    async cloneTo(productionOrder: IProductionOrder) {
        productionOrder.id = this.id;
        productionOrder.code = this.code;
        productionOrder.setProductId(this.getProductId());
        productionOrder.setProductName(this.getProductName());
        productionOrder.setProductLineId(this.getProductLineId());
        productionOrder.setWorkingShiftId(this.getWorkingShiftId());
        productionOrder.setWorkStationId(this.getWorkStationId());
        productionOrder.setSerialNumbers(this.getSerialNumbers());
        productionOrder.setFrom(this.getFrom());
        productionOrder.setUntil(this.getUntil());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت برنامه تولید');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('ایرادی در مقادیر سریال وجود دارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('برنامه تولید با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
            catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت برنامه تولید', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getProductLineId())) {
            result.push('خط تولید مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getWorkStationId())) {
            result.push('ایستگاه کاری مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getWorkingShiftId())) {
            result.push('شیفت کاری مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getProductId())) {
            result.push('محصول مشخص نشده است.');
        }
        if (this.from == null || this.until == null) {
            result.push('سریال مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(productionOrder: IProductionOrder): Promise<any>;
}

export class ProductionOrderInserter implements IServerUpdater {
    async execute(productionOrder: IProductionOrder): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolInstallationServices/CreateProductionOrder', {
                ProductionOrderCode: productionOrder.code,
                ProductId: productionOrder.getProductId(),
                SerialNumbers: productionOrder.getSerialNumbers()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class SerialNumber extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set serialNumber(v: string) { this._serialNumber = v; } public get serialNumber(): string { return this._serialNumber; } private _serialNumber: string;
}
